module.exports = __webpack_public_path__ + "media/react/fonts/fa-regular-400-069eca1bf31ce69acf105557f3ff8ee1.woff";